module.exports = ".loading-container {\n    text-align: center;\n}\n    .loading-container img {\n        width: 35px;\n    }"


//////////////////
// WEBPACK FOOTER
// ./src/app/annuaire/listing/listing.component.css
// module id = ./src/app/annuaire/listing/listing.component.css
// module chunks = main